import React, { useState } from 'react'

interface ColumnProps {
  columnId: string
  headingLabel: string
  initialIsSectionOpen?: boolean
}

function CollapsibleColumn({
  columnId, headingLabel, children, initialIsSectionOpen,
} : React.PropsWithChildren<ColumnProps>) {
  const [isSectionOpen, setIsSectionOpen] = useState<boolean>(!!initialIsSectionOpen)

  return (
    <>
      <div
        className={
          `declaration__column-heading d-flex justify-content-between ${isSectionOpen ? 'mb-2' : 'mb-0'}`
        }
        data-bs-toggle="collapse"
        data-bs-target={`#${columnId}`}
        aria-expanded={isSectionOpen}
        aria-controls={columnId}
        role="button"
        tabIndex={isSectionOpen ? -1 : 0}
        onClick={() => setIsSectionOpen(!isSectionOpen)}
        onKeyDown={() => setIsSectionOpen(!isSectionOpen)}
      >
        <h3>{headingLabel}</h3>
        <i className={`me-2 fa ${isSectionOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
      </div>
      <div className={`collapse ${isSectionOpen ? 'show' : ''}`} id={columnId}>
        {children}
      </div>
    </>
  )
}
CollapsibleColumn.defaultProps = {
  initialIsSectionOpen: true,
}

export default CollapsibleColumn
